export default {
  'accounting.fapiao.link.title': 'Link AR/AP',
  'accounting.fapiao.link.hint':
    'Optional: select AR/AP from this statement. An empty selection keeps the tax invoice linked only to the statement.',
  'accounting.fapiao.link.search': 'Search document, shipment or contact',
  'accounting.fapiao.link.select_all': 'Select entire statement',
  'accounting.fapiao.link.clear': 'Clear selection',
  'accounting.fapiao.link.selected': 'Selected: {count}',
  'accounting.fapiao.link.saved': 'AR/AP links saved',
  'accounting.fapiao.link.load_failed': 'Unable to load AR/AP. Close and try again.',
  'accounting.fapiao.link.save_failed': 'Unable to save AR/AP links',
  'accounting.fapiao.link.type': 'Type',
  'accounting.fapiao.link.code': 'Document number',
  'accounting.fapiao.link.shipment': 'Shipment',
  'accounting.fapiao.link.currency': 'Currency',
  'accounting.fapiao.link.amount': 'Amount (local currency)',

  'accounting.fapiao.list_title.list': 'Fapiao List',
  'accounting.fapiao.add.title': 'Add Fapiao',
  'accounting.fapiao.update.success': 'Successfully updated Fapiao',
  'accounting.fapiao.field.code': 'Code',
  'accounting.fapiao.field.number': 'Number',
  'accounting.fapiao.field.contact': 'Contact',
  'accounting.fapiao.field.amount': 'Amount',
  'accounting.fapiao.field.tax': 'Tax',
  'accounting.fapiao.field.statement': 'Statement',
  'accounting.fapiao.field.issue_date': 'Issue Date',
  'accounting.fapiao.field.verification_code': 'Verification Code',
  'accounting.fapiao.field.remark': 'Remark',
  'accounting.fapiao.field.creator': 'Creator',
  'accounting.fapiao.field.issue_date.required': 'Please select issue date',
  'accounting.fapiao.field.amount.required': 'Please input amount',
  'accounting.fapiao.field.document': 'Documents',
  'accounting.fapiao.field.request_invoicing_by': 'Request Invoicing By',
  'accounting.fapiao.field.list': 'Fapiaos',
  'accounting.fapiao.create.success': 'Successfully Create Fapiao',
  'accounting.fapiao.status.requested': 'Requested Fapiao',
  'accounting.fapiao.status.added': 'Added Fapiao',
  'accounting.fapiao.field.fapiao_status': 'Fapiao Status',
  'accounting.fapiao.field.is_incl_tax': 'Include Tax',
  'accounting.fapiao.type.regular': 'Regular',
  'accounting.fapiao.type.vat': 'VAT',
};
